/**
 * CorrectionCTA — F-005 Phase 4 (IMPL-P4-004).
 *
 * Bottone "Correggi pratica" che porta al wizard di correzione (Phase 5).
 * Naviga a `/app/pratiche/nuova?correctMode=1&id=<praticaId>` (la pagina
 * `NuovaPraticaPage` riconosce il searchParam `correctMode=1` e si
 * pre-popola con i datiStrutturati attuali della pratica).
 *
 * Usa `Button asChild` + `Link` per ottenere il rendering button-style con
 * la semantica dell'ancora (corretta navigazione SPA + accessibilità nativa).
 */
import { Link } from 'react-router-dom';
import { Pencil } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

interface CorrectionCTAProps {
  praticaId: string;
  className?: string;
}

export function CorrectionCTA({ praticaId, className }: CorrectionCTAProps) {
  return (
    <Button asChild variant="destructive" size="sm" className={cn(className)}>
      <Link to={`/app/pratiche/nuova?correctMode=1&id=${praticaId}`}>
        <Pencil className="mr-1.5 h-3 w-3" aria-hidden="true" />
        Correggi pratica
      </Link>
    </Button>
  );
}
